export const eventNames = {
  blockTypeChange: 'blockTypeChange',
  inlineStyleChange: 'inlineStyleChange',
  selectionCollapsedChange: 'selectionCollapsedChange',
  modalDataChange: 'modalDataChange',
};

export const modalNames = {
  link: 'link',
  phone: 'phone',
};

export const toolbarBlockNames = {
  heading: 'heading',
  inlineStyle: 'inlineStyle',
  list: 'list',
  link: 'link',
  phoneLink: 'phoneLink',
};
